module.exports = __webpack_public_path__ + "static/media/close_light_icon.0a106600.svg";